import vue from 'vue'
import EditAvatar from './EditAvatar'
import store from '@/store/index'
const EditAvatarCreater = vue.extend(EditAvatar)
let editAvatarInstance

export default {
  open (userInfor) {
    if (!editAvatarInstance) {
      editAvatarInstance = new EditAvatarCreater({
        el: document.createElement('div'),
        data () {
          return {
            userInfor: userInfor
          }
        },
        store,
      })
      document.body.appendChild(editAvatarInstance.$el)
    }
    editAvatarInstance.visible = true
  }
}